// Turkish: the first catalog and the source of the keys. Every text the app shows comes from
// a catalog; never write UI text inline in a component. "{name}" marks a value filled in by
// format() (src/i18n/index.ts); a catalog keeps the same placeholders for each key.

export const tr = {
  appTitle: 'Versiyonbir Toplantı Salonu',

  lobbyNewHeading: 'Yeni toplantı',
  lobbyJoinHeading: 'Toplantıya katılın',
  lobbyMeetingCode: 'Toplantı kodu: {code}',
  nameLabel: 'Adınız',
  nameHint: 'Toplantıdakiler bu adı görür.',
  languageLabel: 'Konuştuğunuz dil',
  languageHint: 'Başka dilde konuşanları bu dile çevrilmiş olarak duyar ve okursunuz.',
  deviceHeading: 'Kamera ve mikrofon',
  cameraStartsOn: 'Kamera açık katılayım',
  microphoneStartsOn: 'Mikrofon açık katılayım',
  cameraDevice: 'Kamera',
  microphoneDevice: 'Mikrofon',
  defaultDevice: 'Varsayılan aygıt',
  previewLabel: 'Kamera önizlemesi',
  previewOff: 'Kamera kapalı',
  microphoneLevel: 'Mikrofon ses düzeyi',
  devicesError: 'Kameraya ya da mikrofona erişilemedi. Tarayıcının adres çubuğundaki izinlerden açabilirsiniz.',
  headphonesTip: 'Kulaklık takmanızı öneririz: böylece çeviri sesi mikrofonunuza karışmaz.',
  startMeeting: 'Toplantıyı başlat',
  joinMeeting: 'Katıl',
  connecting: 'Bağlanılıyor…',
  errorName: 'Lütfen adınızı yazın (en fazla 48 karakter).',
  errorConnect: 'Toplantıya bağlanılamadı. Lütfen biraz sonra yeniden deneyin.',
  errorRateLimited: 'Kısa sürede çok fazla deneme yapıldı. Lütfen bir dakika sonra yeniden deneyin.',
  errorInvalidLink: 'Bu toplantı bağlantısı geçerli değil. Yeni bir toplantı başlatabilirsiniz.',

  privacyHeading: 'Gizlilik',
  privacyNotice:
    'Bu toplantıda canlı çeviri ve not alma açıktır. Konuşmalar yazıya dökülür ve çevrilir; ' +
    'toplantının sonunda bir özet hazırlanır. Bunun için ses Deepgram, metin Anthropic ve çeviri ' +
    'sesi ElevenLabs hizmetlerinde işlenir. Ses kaydedilmez. Konuşma metni yalnızca toplantı ' +
    'sürerken tutulur ve ' +
    'toplantı bitince silinir; notlar yalnızca toplantıdakilere gösterilir. Rezervasyonla yapılan ' +
    'bir toplantının notları, rezervasyonla birlikte Versiyonbir\u2019in müşteri kayıtlarında (CRM) ' +
    'saklanır. Toplantıyı başlatan kişi, konuşmayı izleyip yalnızca ona sorulacak soruları öneren ' +
    'bir asistanı açabilir. Yazılı mesajlar ve dosyalar yalnızca toplantıdakilere iletilir, ' +
    'saklanmaz.',
  privacyShort: 'Canlı çeviri ve not alma açık: konuşmalar yazıya dökülür ve çevrilir.',
  privacyDetails: 'Ayrıntılar',

  meetingCode: 'Kod: {code}',
  copyInvite: 'Davet bağlantısını kopyala',
  inviteCopied: 'Davet bağlantısı kopyalandı.',
  inviteCopyFailed: 'Bağlantı kopyalanamadı. Bağlantı: {url}',
  openInNewTab: 'Yeni sekmede aç',
  controlsLabel: 'Toplantı denetimleri',
  microphone: 'Mikrofon',
  camera: 'Kamera',
  screenShare: 'Ekranı paylaş',
  notes: 'Notlar',
  leave: 'Ayrıl',
  modeLabel: 'Çeviri',
  modeVoice: 'Sesli çeviri',
  modeSubtitles: 'Yalnızca altyazı',
  modeOff: 'Kapalı',
  copilot: 'Asistan',
  copilotHeading: 'Toplantı asistanı',
  copilotHide: 'Gizle',
  copilotStop: 'Asistanı durdur',
  copilotStart: 'Asistanı başlat',
  copilotRunning: 'çalışıyor',
  copilotStopped: 'Asistan durduruldu. Başlatınca konuşmayı izlemeye devam eder.',
  copilotSummaryHeading: 'Müşteri ne istiyor',
  copilotChecklistHeading: 'Netleştirilecekler',
  copilotSuggestionsHeading: 'Şimdi sorabilirsiniz',
  copilotEmpty: 'Asistan konuşmayı dinliyor; ilk öneriler birkaç cümle sonra burada görünür.',
  copilotDone: 'tamamlandı',
  copilotOpen: 'açık',
  startAudio: 'Sesi başlat',
  reconnecting: 'Bağlantı yeniden kuruluyor…',
  interpreterPresent: 'Tercüman toplantıda.',
  interpreterAbsent: 'Tercüman henüz katılmadı.',
  you: '{name} (siz)',
  someone: 'Bir katılımcı',
  participantCount: '{count} katılımcı',

  subtitlesLabel: 'Canlı altyazı',
  subtitleTranslating: 'Çevriliyor…',
  subtitleUnclear: 'Anlaşılamadı',

  transcript: 'Yazı dökümü',
  transcriptHeading: 'Yazı dökümü',
  transcriptEmpty: 'Konuşulanlar burada cümle cümle, sizin dilinizde görünür.',
  transcriptClose: 'Yazı dökümünü kapat',

  chat: 'Sohbet',
  chatHeading: 'Sohbet',
  chatEmpty: 'Yazılı mesajlar ve dosyalar burada görünür. Yalnızca toplantıdakilere iletilir, saklanmaz.',
  chatMessagesLabel: 'Mesajlar',
  chatMessageLabel: 'Mesaj',
  chatPlaceholder: 'Mesaj yazın',
  chatSend: 'Gönder',
  chatSendFile: 'Dosya gönder',
  chatFileTooLarge: 'Dosya çok büyük: en fazla {max} MB.',
  chatSendFailed: 'Mesaj gönderilemedi.',
  chatFileFailed: 'Dosya gönderilemedi.',
  chatSending: 'Gönderiliyor… {percent}%',
  chatFile: '{name} ({size})',
  chatDownload: 'İndir',
  chatClose: 'Sohbeti kapat',
  chatUnread: '{count} yeni',

  speaks: '{name}: {language}',
  translationOn: 'Çeviri açık',
  translationNotNeeded: 'Herkes {language} konuşuyor, çeviri gerekmiyor',
  alone: 'Henüz yalnızsınız',

  notesHeading: 'Toplantı notları',
  notesEmpty: 'Toplantı notları, toplantının sonunda burada görünecek.',
  notesSummary: 'Özet',
  notesDecisions: 'Kararlar',
  notesActions: 'Yapılacaklar',
  notesOwner: 'Sorumlu: {owner}',
  notesDue: 'Son tarih: {due}',
  notesClose: 'Notları kapat',

  leftHeading: 'Toplantıdan ayrıldınız',
  leftUnexpected: 'Bağlantı koptu.',
  rejoin: 'Yeniden katıl',
  newMeeting: 'Yeni toplantı başlat',
};

export type MessageKey = keyof typeof tr;
export type Catalog = Readonly<Record<MessageKey, string>>;
